@if(view.site) {
<div class="w-full relative border-b-4 border-primary-500">
  @if(options?.imageHref) {
    <div class="relative w-full min-h-[280px] bg-primary-100">
      <img [src]="options.imageHref" alt="Banner" class="w-full h-auto block transition-opacity duration-300"
        [class.opacity-0]="!view.bannerLoaded || view.bannerError"
        [class.opacity-100]="view.bannerLoaded && !view.bannerError"
        (error)="view.bannerError = true"
        (load)="view.bannerLoaded = true" />
    </div>
  }
  @if(!options?.imageHref) {
    <div class="w-full h-[280px] bg-primary-100" aria-hidden="true"></div>
  }
  @if(options?.title) {
    <div class="absolute inset-0 flex flex-col justify-center items-center z-10 px-4 pointer-events-none">
      <h1 class="text-white text-center text-4xl lg:text-7xl font-semibold text-shadow uppercase tracking-wider">
        {{ options.title }}
      </h1>
    </div>
  }
</div>

}